import account from './account/id-ID.json';
import affiliate from './affiliate/id-ID.json';
import component from './component/id-ID.json';
import menus from './menus/id-ID.json';
import user from './users/id-ID.json';
import global from './global/id-ID.json';
import support from './support/id-ID.json';
import result from './result/id-ID.json';
import finance from './finance/id-ID.json';
import region from './region/id-ID.json';
import request from './request/id-ID.json';
// 因不知名原因，当存在menu和user文件夹时，i18n-ally插件没反应，故修改文件名为menus,users

const titleMenu = Object.entries(menus).reduce((pre: object, [key, value]: [string, string]) => {
  // 添加统一后缀
  return {
    ...pre,
    [`title.${key}`]: `${value} - LightNode`,
  };
}, {});

export default {
  ...account,
  ...affiliate,
  ...component,
  ...menus,
  ...titleMenu,
  ...user,
  ...global,
  ...support,
  ...result,
  ...finance,
  ...region,
  ...request,
};
